@if (isLogged()) {
  @if (isMobile()) {
    <div ngbDropdown placement="bottom-end">
      <button type="button" class="avatar-toggle" ngbDropdownToggle aria-label="User menu">
        <sas-avatar size="sm" shape="round"
          [bgColor]="'linear-gradient(135deg, #cdd0ff, #9aa1ff)'"
          [textColor]="'#ffffff'"
          ariaLabel="User avatar">{{ avatarInitials() }}</sas-avatar>
      </button>
      <div ngbDropdownMenu>
        <span class="dropdown-item-text fw-semibold" (click)="navigateToProfile()" (keydown.enter)="navigateToProfile()" tabindex="0">{{ username() }}</span>
        <hr class="dropdown-divider">
        <a ngbDropdownItem
           (click)="identityCommonService.logout()"
           translate="SIGN_OUT"
           [routerLink]="clientUrl() + '/' + signOutPath">
        </a>
      </div>
    </div>
  } @else {
    <div class="user d-flex align-items-center cursor-pointer" (click)="navigateToProfile()" (keydown.enter)="navigateToProfile()" tabindex="0">
      <sas-avatar size="sm" shape="round"
        [bgColor]="'linear-gradient(135deg, #cdd0ff, #9aa1ff)'"
        [textColor]="'#ffffff'"
        ariaLabel="User avatar">{{ avatarInitials() }}</sas-avatar>
      <div class="meta">
        <div class="name fw-semibold">{{ username() }}</div>
        @if (userRole()) { <div class="role">{{ userRole() }}</div> }
      </div>
    </div>
    <a class="btn btn-primary"
       (click)="identityCommonService.logout()"
       translate="SIGN_OUT"
       [routerLink]="clientUrl() + '/' + signOutPath">
    </a>
  }
} @else {
  <a class="btn btn-primary"
     translate="SIGN_IN"
     [routerLink]="clientUrl() + '/signIn'">
  </a>
}
